const TOKEN_KEY = 'abacus_token';
const USER_KEY = 'abacus_user';

export type AuthUser = { id: number; username: string; role: 'user' | 'admin' };

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}
export function setAuth(token: string, user: AuthUser) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}
export function getUser(): AuthUser | null {
  const s = localStorage.getItem(USER_KEY);
  if (!s) return null;
  try {
    return JSON.parse(s) as AuthUser;
  } catch {
    return null;
  }
}
export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export type ApiError = { code: string; message: string; request_id: string };
export type ApiResponse<T> = { ok: true; data: T } | { ok: false; error: ApiError };

export async function api<T = unknown>(
  path: string,
  init: RequestInit = {},
): Promise<ApiResponse<T>> {
  const headers = new Headers(init.headers);
  const token = getToken();
  if (token) headers.set('Authorization', `Bearer ${token}`);
  const isForm = init.body instanceof FormData;
  if (!headers.has('Content-Type') && init.body && !isForm) {
    headers.set('Content-Type', 'application/json');
  }
  const resp = await fetch(path, { ...init, headers });
  const text = await resp.text();
  let parsed: ApiResponse<T>;
  try {
    parsed = JSON.parse(text) as ApiResponse<T>;
  } catch {
    return {
      ok: false,
      error: {
        code: 'INTERNAL',
        message: `HTTP ${resp.status}: ${text.slice(0, 200)}`,
        request_id: '',
      },
    };
  }
  if (!parsed.ok) {
    const c = parsed.error.code;
    if (c === 'AUTH_TOKEN_STALE' || c === 'AUTH_UNAUTHENTICATED' || c === 'AUTH_DISABLED') {
      clearAuth();
      if (!location.pathname.startsWith('/login')) {
        setTimeout(() => {
          location.href = '/login';
        }, 50);
      }
    }
  }
  return parsed;
}
